import { z } from "zod";

export const ZInnledningSchema = z.object({
  // 1
  isActive: z.boolean().default(true),
  tekst: z.string(),
  formelleForhold: z.object({
    // 1.1
    isActive: z.boolean().default(true),
    tekst: z.string(),
  }),
});

export type IInnledningSchema = z.infer<typeof ZInnledningSchema>;
